(function () {
    const $$ = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];

    const cssThumb = '.product-thumbnail.hide-image{display:none!important;}',
          cssSlide = '.product-images__slide.hide-slide{display:none!important;}';

    [ ['css-thumb', cssThumb], ['css-slide', cssSlide] ].forEach(([id, css]) => {
        if (!document.getElementById(id)) {
            const s = document.createElement('style');
            s.id = id;
            s.textContent = css;
            document.head.appendChild(s);
        }
    });

    let patronesCache = null, filtrando = false;

    /* ─── AGRUPACIÓN ADAPTATIVA POR VARIANTE ───────────────── */
    const obtenerDigitos = id => (id.match(/-(\d+)$/) || [,''])[1];

    function longitudPrefijoIdeal() {
        const thumbs    = $$('#Product-Thumbnails .product-thumbnail');
        const variantes = thumbs.filter(t =>
            t.classList.contains('product-images__slide-item--variant')
        );
        if (!variantes.length) return 5;

        const digVar = variantes.map(t => obtenerDigitos(t.id));
        const total  = digVar.length;

        for (let len = 5; len <= 12; len++) {
            const set = new Set(digVar.map(d => d.slice(0, len)));
            if (set.size === total) return len;
        }
        return 8
    }

    /* Devuelve el prefijo que identifica la variante */
    const extraerPatron = (() => {
        let prefLen = null;
        return id => {
            if (prefLen == null) prefLen = longitudPrefijoIdeal();
            const dig = obtenerDigitos(id);
            return dig ? dig.slice(0, prefLen) : '';
        };
    })();

    function detectarPatrones() {
        if (patronesCache) return patronesCache;
        const grupos = {};
        $$('#Product-Thumbnails .product-thumbnail').forEach(t => {
            const p = extraerPatron(t.id);
            if (p) (grupos[p] ??= []).push(t.id);
        });   
        return patronesCache = grupos;
    }

    function obtenerColorSeleccionado() {
        const inpt = document.querySelector(
            '.product-form__input--color input[type="radio"]:checked'
        );
        if (!inpt) return null;
        return {
            valor       : inpt.value,
            normalizado : inpt.value.toLowerCase().replace(/\s+/g, '-'),
            elemento    : inpt
        };
    }

    /* Mapea colores ↔ patrones */
    function asociarColoresConPatrones() {
        const patrones = detectarPatrones(),
              colores  = $$('.product-form__input--color input[type="radio"]');
        const keysPat = Object.keys(patrones);
        if (keysPat.length === colores.length) {
            const map = {};
            colores.forEach((c, i) =>
                map[c.value.toLowerCase().replace(/\s+/g, '-')] = keysPat[i]
            );
            return map;
        }
        return {};
    }

    const asociaciones = asociarColoresConPatrones();

    function obtenerPatronDeColor() {
        const col = obtenerColorSeleccionado();
        if (!col) return null;

        let pat = asociaciones[col.normalizado];
        if (!pat) {
            for (const [c, p] of Object.entries(asociaciones)) {
                if (col.normalizado.includes(c) || c.includes(col.normalizado)) {
                    pat = p;
                    break;
                }
            }
        }
        if (!pat) {
            const radios = $$('.product-form__input--color input[type="radio"]'),
                  keys   = Object.keys(detectarPatrones());
            if (keys.length) {
                const idx = radios.findIndex(r => r === col.elemento);
                if (idx > -1 && idx < keys.length) pat = keys[idx];
            }
        }
        return pat;
    }

    /* --- Sincronizar clases en thumbnails --- */
    function syncThumbClasses() {
        const thumbs = $$('#Product-Thumbnails .product-thumbnail');
        const firstVisible = thumbs.find(t => !t.classList.contains('hide-image'));

        thumbs.forEach(t => t.classList.remove(
            'is-active', 'is-selected', 'is-initial-selected'
        ));
        if (firstVisible)
            firstVisible.classList.add('is-active', 'is-initial-selected');
    }

    function filtrarMiniaturas() {
        const patron   = obtenerPatronDeColor();
        const patrones = detectarPatrones();
        const idsOk    = patron ? new Set(patrones[patron] || []) : null;

        let visibles = 0;
        $$('#Product-Thumbnails .product-thumbnail').forEach(t => {
            const show = !idsOk || idsOk.has(t.id);
            t.classList.toggle('hide-image', !show);
            if (show) visibles++;
        });
        if (visibles === 0)
            $$('#Product-Thumbnails .product-thumbnail').forEach(t => t.classList.remove('hide-image'));

        syncThumbClasses();
    }

    function aplicarFiltro() {
        if (filtrando) return;
        filtrando = true;
        setTimeout(() => {
            patronesCache = null;
            filtrarMiniaturas();
            filtrando = false;
        }, 100);
    }

    /* ─── BLOQUE SLIDES / FLICKITY ─── */
    function initSlides() {
        const sliderContainer = document.querySelector('product-slider.flickity-enabled'),
              flickitySlider  = document.querySelector('.flickity-slider'),
              thumbsContainer = document.getElementById('Product-Thumbnails');
        if (!sliderContainer || !thumbsContainer || !flickitySlider) return;

        const flkty = window.Flickity && window.Flickity.data(sliderContainer);
        if (flkty) flkty.options.cellSelector = '.product-images__slide:not(.hide-slide)';

        let slidesVisibles = [], maxX = 0, curX = 0;

        const updateThumbActiveFromSlide = idx => {
            const idSlide = slidesVisibles[idx]?.id || '';
            $$('#Product-Thumbnails .product-thumbnail').forEach(t => {
                const act = t.id.replace('Thumb-', 'Slide-') === idSlide;
                t.classList.toggle('is-active', act);
                t.classList.toggle('is-initial-selected', act);
            });
        };

        const reorganizarSlides = () => {
            const idsVisibles = $$('.product-thumbnail:not(.hide-image)', thumbsContainer)
                                .map(t => t.id.replace('Thumb-', 'Slide-'));

            $$('.product-images__slide', sliderContainer).forEach(sl => {
                const ok = idsVisibles.includes(sl.id);
                sl.classList.toggle('hide-slide', !ok);
                if (!ok) sl.style.transform = '';
            });

            if (flkty) {
                flkty.reloadCells();
                flkty.resize();
            }

            slidesVisibles = $$('.product-images__slide:not(.hide-slide)', sliderContainer)
                                .map((s, i) => (s.style.transform = `translateX(${i * 100}%)`, s));
            maxX = -(slidesVisibles.length - 1) * 100;

            const sel = sliderContainer.querySelector('.product-images__slide.is-selected:not(.hide-slide)');
            const idx = sel ? slidesVisibles.indexOf(sel) : 0;
            slidesVisibles.forEach((s, i) => s.classList.toggle('is-selected', i === idx));
            curX = -idx * 100;
            flickitySlider.style.transform = `translateX(${curX}%)`;

            updateThumbActiveFromSlide(idx);
        };

        const navegar = dir => {
            const next = curX - dir * 100;
            curX = next < maxX ? 0 : next > 0 ? maxX : next;
            flickitySlider.style.transform = `translateX(${curX}%)`;
            const idx = Math.abs(curX) / 100;
            slidesVisibles.forEach((s, i) => s.classList.toggle('is-selected', i === idx));
            updateThumbActiveFromSlide(idx);
        };

        ['previous', 'next'].forEach(cls => {
            const btn = sliderContainer.querySelector(`.flickity-button.${cls}`);
            btn?.addEventListener('click', e => {
                e.preventDefault();
                e.stopImmediatePropagation();
                navegar(cls === 'next' ? 1 : -1);
            }, true);
        });

        new MutationObserver(reorganizarSlides)
            .observe(thumbsContainer, { attributes: true, subtree: true });

        window.addEventListener('resize', () => setTimeout(reorganizarSlides, 200));

        reorganizarSlides();
    }

    function boot() {
        aplicarFiltro();
        const colorWrap = document.querySelector('.product-form__input--color');
        colorWrap?.addEventListener('change', e => {
            if (e.target.type === 'radio') aplicarFiltro();
        });

        setTimeout(initSlides, 500);
    }

    document.readyState === 'loading'
        ? document.addEventListener('DOMContentLoaded', boot)
        : boot();
})();
